import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const LoginForm = props => {
  const { handleSubmit, submitting, message } = props;
  return (
    <form onSubmit={handleSubmit}>
      {message && <div className="login-error">{message}</div>}
      <Field
        required
        name="username"
        type="text"
        component={FormField.Input}
        placeholder="Username"
        validate={[value => value ? undefined : 'Required']}
      />
      <Field
        required
        name="password"
        type="password"
        component={FormField.Input}
        placeholder="Password"
        validate={[value => value ? undefined : 'Required']}
      />
      <Button bsStyle="primary" type="submit" disabled={submitting}>
        Log in
      </Button>
      <div className="reset">
        <Link to="/password-reset">
          Reset my password
        </Link>
      </div>
    </form>
  );
};

export default reduxForm({ form: 'login' })(LoginForm);



// WEBPACK FOOTER //
// ./src/components/routes/clientLogin/LoginForm.js